module.exports = __webpack_public_path__ + "img/HuaweiWhite.437ebedb.png";